import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'mg-mango-layout',
  template: `
    <p>
      mango-layout works!
    </p>
  `,
  styles: [
  ]
})
export class MangoLayoutComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
